import { PropertiesTableProps } from '../../../../shared/types'

import { ListFormatProperties } from '../../../../components/list-format/ListFormatDocs'

export const ArraySelectionProperties: PropertiesTableProps = {
  ...ListFormatProperties,
}
